import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase';
import { doc, getDoc, setDoc } from "firebase/firestore";
import './VersionManager.css';

const VersionManager = () => {
    const [selectedPlatform, setSelectedPlatform] = useState('android'); // 'android' or 'ios'

    // Versions state
    const [androidVersion, setAndroidVersion] = useState({ major: 0, minor: 0, patch: 0 });
    const [iosVersion, setIosVersion] = useState({ major: 0, minor: 0, patch: 0 });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const getDocId = (platform) => {
        return platform === 'android' ? 'currentVersion' : 'iosVersion';
    };

    // Field names mapping for Wordly
    const getFieldNames = () => {
        return { x: 'x', y: 'y', z: 'z' };
    };

    useEffect(() => {
        const fetchVersions = async () => {
            setLoading(true);
            setMessage(null);
            try {
                const androidDocRef = doc(firestore, 'settings', getDocId('android'));
                const androidSnap = await getDoc(androidDocRef);

                const iosDocRef = doc(firestore, 'settings', getDocId('ios'));
                const iosSnap = await getDoc(iosDocRef);

                const fields = getFieldNames();

                if (androidSnap.exists()) {
                    const data = androidSnap.data();
                    setAndroidVersion({
                        major: data[fields.x] || 0,
                        minor: data[fields.y] || 0,
                        patch: data[fields.z] || 0
                    });
                }

                if (iosSnap.exists()) {
                    const data = iosSnap.data();
                    setIosVersion({
                        major: data[fields.x] || 0,
                        minor: data[fields.y] || 0,
                        patch: data[fields.z] || 0
                    });
                }
            } catch (error) {
                console.error("Error fetching versions:", error);
                setMessage({ type: 'error', text: "Failed to fetch versions. " + error.message });
            } finally {
                setLoading(false);
            }
        };

        fetchVersions();
    }, []);


    const handleSave = async (platform) => {
        setLoading(true);
        setMessage(null);
        try {
            const docId = getDocId(platform);
            const version = platform === 'android' ? androidVersion : iosVersion;
            const fields = getFieldNames();

            const updateData = {
                [fields.x]: parseInt(version.major),
                [fields.y]: parseInt(version.minor),
                [fields.z]: parseInt(version.patch)
            };

            await setDoc(doc(firestore, 'settings', docId), updateData, { merge: true });
            setMessage({ type: 'success', text: `${platform.toUpperCase()} version updated successfully!` });

        } catch (error) {
            console.error("Error saving version:", error);
            setMessage({ type: 'error', text: "Failed to save version. " + error.message });
        } finally {
            setLoading(false);
        }
    };

    const currentVersion = selectedPlatform === 'android' ? androidVersion : iosVersion;
    const setVersion = selectedPlatform === 'android' ? setAndroidVersion : setIosVersion;

    return (
        <div className="version-manager-container">
            <h1>App Version Control</h1>

            <div className="platform-selector">
                <button
                    className={selectedPlatform === 'android' ? 'active' : ''}
                    onClick={() => setSelectedPlatform('android')}>Android</button>
                <button
                    className={selectedPlatform === 'ios' ? 'active' : ''}
                    onClick={() => setSelectedPlatform('ios')}>iOS</button>
            </div>

            <div className="block" style={{ marginTop: '20px' }}>
                <h3 style={{ marginBottom: '24px' }}>Wordly - {selectedPlatform.toUpperCase()} Version</h3>

                <div className="input-group">
                    <label>Major Release (x)</label>
                    <input type="number" value={currentVersion.major} onChange={(e) => setVersion({ ...currentVersion, major: e.target.value })} />
                </div>
                <div className="input-group">
                    <label>Minor Update (y)</label>
                    <input type="number" value={currentVersion.minor} onChange={(e) => setVersion({ ...currentVersion, minor: e.target.value })} />
                </div>
                <div className="input-group">
                    <label>Patch/Hotfix (z)</label>
                    <input type="number" value={currentVersion.patch} onChange={(e) => setVersion({ ...currentVersion, patch: e.target.value })} />
                </div>

                <div className="actions" style={{ marginTop: '32px' }}>
                    <button onClick={() => handleSave(selectedPlatform)} disabled={loading} className="primary-btn" style={{ width: '100%' }}>
                        {loading ? 'Saving...' : 'Update Production Version'}
                    </button>
                </div>
            </div>

            {message && (
                <div className={`message ${message.type}`} style={{
                    marginTop: '20px',
                    padding: '16px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    background: message.type === 'success' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                    color: message.type === 'success' ? 'var(--accent)' : 'var(--error)',
                    border: `1px solid ${message.type === 'success' ? 'var(--accent)' : 'var(--error)'}`
                }}>
                    {message.text}
                </div>
            )}
        </div>
    );
};

export default VersionManager;
